import KtButton from './KtButton'
import KtTable from './KtTable'
import KtMaxHeight from './KtMaxHeight'
import BaseSearch from './BaseSearch'


const install = function (Vue, config = {}) {
  if (install.installed) return
  Vue.component(KtButton.name, KtButton)
  Vue.component(KtTable.name, KtTable)
  Vue.component(KtMaxHeight.name, KtMaxHeight)
  Vue.component(BaseSearch.name, BaseSearch)
}

export default {
  install
}
